import React from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";

const BulkEmailModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="bg-dark text-white">
        <Modal.Title>
          <FaEnvelope className="me-2" />
          Send Announcement Email
        </Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Alert variant="info">
            <strong>📧 Email Announcements</strong>
            <p className="mt-2 mb-0">
              Send announcements with attachments to all users. Emails will be
              saved in the announcements table for future reference.
            </p>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <Button variant="dark" disabled>
            Coming Soon
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default BulkEmailModal;
